import React, { useEffect, useState } from "react"
import axios from "axios"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"


const FORM_VAZIO = {
  imei:"", nome:"", marca:"", modelo:"", numero_serie:"",
  chip_id:"", servidor:"", porta:"", data_compra:"", observacoes:""
}

const STATUS_CORES:Record<string,{bg:string,cor:string,label:string}> = {
  em_uso:    {bg:"#14532d", cor:"#4ade80", label:"Em uso"},
  estoque:   {bg:"#0c2a4a", cor:"#38bdf8", label:"Estoque"},
  manutencao:{bg:"#451a03", cor:"#fbbf24", label:"Manutenção"},
}

// o servidor grava "instalado" ao vincular a um ativo (e ha registros "ativo"): na tela, ambos sao "Em uso"
const normalizarStatus = (d:any) => {
  const st = d.status
  if (st==="manutencao" || st==="estoque" || st==="em_uso") return st
  if (st==="instalado" || st==="ativo" || d.ativo_nome) return "em_uso"
  return "estoque"
}

export default function Rastreadores() {
  const [dados, setDados]       = useState<any[]>([])
  const [chips, setChips]       = useState<any[]>([])
  const [clientes, setClientes] = useState<any[]>([])
  const [modal, setModal]       = useState(false)
  const [modalHist, setModalHist] = useState<any>(null)
  const [historico, setHistorico] = useState<any[]>([])
  const [editando, setEditando] = useState<any>(null)
  const [form, setForm]         = useState<any>(FORM_VAZIO)
  const [busca, setBusca]       = useState("")
  const [loading, setLoading]   = useState(true)
  const [abaAtiva, setAbaAtiva] = useState<"em_uso"|"estoque"|"manutencao">("em_uso")
  const [filtroCliente, setFiltroCliente] = useState("")
  const [modeloInfo, setModeloInfo] = useState<any>(null)
  const [catalogoModelos, setCatalogoModelos] = useState<any[]>([])
  const [modalModelos, setModalModelos] = useState(false)
  const carregarCatalogoModelos = async () => {
    try {
      const r = await axios.get(`${API}/modelos-rastreador`)
      const agrupado: Record<string, any[]> = {}
      for (const m of r.data) {
        if (!agrupado[m.fabricante]) agrupado[m.fabricante] = []
        agrupado[m.fabricante].push({ modelo: m.modelo, servidor: m.servidor || '', porta: m.porta || 0 })
      }
      setCatalogoModelos(Object.entries(agrupado).map(([marca, modelos]) => ({ marca, modelos })))
    } catch {}
  }

  const carregar = async () => {
    try {
      const [r, ch, cl] = await Promise.all([
        axios.get(`${API}/rastreadores`),
        axios.get(`${API}/chips`),
        axios.get(`${API}/clientes`)
      ])
      setDados(r.data.map((d:any)=>({...d, status: normalizarStatus(d)})))
      setChips(ch.data.filter((c:any)=>c.status!=="cancelado"))
      setClientes(cl.data)
    } catch {} finally { setLoading(false) }
  }

  useEffect(()=>{ carregar(); carregarCatalogoModelos() },[])

  const abrirNovo = () => { setEditando(null); setForm(FORM_VAZIO); setModeloInfo(null); setModal(true) }
  const abrirEditar = (r:any) => {
    setEditando(r)
    setForm({
      imei:r.imei||"", nome:r.nome||"", marca:r.marca||"", modelo:r.modelo||"",
      numero_serie:r.numero_serie||"", chip_id:r.chip_id||"",
      servidor:r.servidor||"", porta:r.porta||"",
      data_compra:r.data_compra?r.data_compra.split("T")[0]:"",
      observacoes:r.observacoes||""
    })
    const mInfo = catalogoModelos.find((m:any)=>m.marca===r.marca)?.modelos.find((m:any)=>m.modelo===r.modelo)
    setModeloInfo(mInfo||null)
    setModal(true)
  }

  const selecionarModelo = (marca:string, modelo:string) => {
    const mInfo = catalogoModelos.find((m:any)=>m.marca===marca)?.modelos.find((m:any)=>m.modelo===modelo)
    setModeloInfo(mInfo||null)
    setForm((f:any)=>({...f, marca, modelo,
      servidor: mInfo?.servidor||"",
      porta: mInfo?.porta||""
    }))
  }

  const salvar = async () => {
    if (!form.imei) return alert("IMEI é obrigatório")
    if (!form.chip_id) return alert("Chip SIM é obrigatório")
    if (!form.marca) return alert("Marca é obrigatória")
    if (!form.modelo) return alert("Modelo é obrigatório")
    try {
      // Campos que podem ser apagados (enviar null explicitamente)
      const camposLimpaveis = ["nome","numero_serie","observacoes","servidor","porta","data_compra"]
      const payload:any = {}
      for (const [k,v] of Object.entries(form)) {
        if (v !== "" && v !== null && v !== undefined) payload[k] = v
        else if (camposLimpaveis.includes(k)) payload[k] = null
      }
      if (editando) await axios.put(`${API}/rastreadores/${editando.id}`, payload)
      else await axios.post(`${API}/rastreadores`, payload)
      setModal(false); carregar()
    } catch(e:any) { alert(e.response?.data?.erro||"Erro ao salvar") }
  }

  const mudarStatus = async (id:string, status:string) => {
    try { await axios.put(`${API}/rastreadores/${id}`, {status}); carregar() } catch {}
  }

  const abrirHistorico = async (r:any) => {
    setModalHist(r)
    try {
      const res = await axios.get(`${API}/rastreadores/${r.id}/historico`)
      setHistorico(res.data)
    } catch { setHistorico([]) }
  }

  const counts = {
    em_uso:     dados.filter(d=>d.status==="em_uso").length,
    estoque:    dados.filter(d=>d.status==="estoque"||!d.status).length,
    manutencao: dados.filter(d=>d.status==="manutencao").length,
  }

  const filtrados = dados.filter(d => {
    if (abaAtiva==="estoque" && d.status!=="estoque" && d.status) return false
    if (abaAtiva==="em_uso" && d.status!=="em_uso") return false
    if (abaAtiva==="manutencao" && d.status!=="manutencao") return false
    if (filtroCliente && d.cliente_id!==filtroCliente) return false
    if (busca && !d.imei?.includes(busca) && !d.nome?.toLowerCase().includes(busca.toLowerCase())) return false
    return true
  })

  const marcaSelecionada = catalogoModelos.find(m=>m.marca===form.marca)

  const [relatorio, setRelatorio] = useState(false)
  const [relFiltros, setRelFiltros] = useState({
    cliente_id:"", status:"", inicio:"", fim:""
  })

  const dadosFiltradosRel = dados.filter(d=>{
    if(relFiltros.cliente_id && d.ativo_cliente_id!==relFiltros.cliente_id && d.cliente_id!==relFiltros.cliente_id) return false
    if(relFiltros.status && d.status!==relFiltros.status) return false
    return true
  })

  return (
    <div style={{padding:24,height:"100%",overflowY:"auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div>
          <h2 style={{fontSize:20,fontWeight:700}}>📡 Rastreadores</h2>
          <p style={{fontSize:13,color:"#64748b"}}>{filtrados.length} registro(s)</p>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button className="btn btn-ghost" onClick={()=>setRelatorio(!relatorio)}>📊 Relatório</button>
          <button className="btn btn-ghost" onClick={()=>setModalModelos(true)}>⚙️ Modelos</button>
          <button className="btn btn-primary" onClick={abrirNovo}>+ Novo rastreador</button>
        </div>
      </div>

      {/* Relatório */}
      {relatorio && (
        <div className="card" style={{marginBottom:16}}>
          <div style={{fontWeight:700,fontSize:14,marginBottom:12}}>📊 Relatório de rastreadores</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr auto",gap:12,alignItems:"end",marginBottom:16}}>
            <div className="form-group" style={{margin:0}}>
              <label>Cliente</label>
              <select value={relFiltros.cliente_id} onChange={e=>setRelFiltros({...relFiltros,cliente_id:e.target.value})}>
                <option value="">Todos</option>
                {clientes.map((c:any)=><option key={c.id} value={c.id}>{c.razao_social}</option>)}
              </select>
            </div>
            <div className="form-group" style={{margin:0}}>
              <label>Status</label>
              <select value={relFiltros.status} onChange={e=>setRelFiltros({...relFiltros,status:e.target.value})}>
                <option value="">Todos</option>
                <option value="em_uso">Em uso</option>
                <option value="estoque">Estoque</option>
                <option value="manutencao">Manutenção</option>
              </select>
            </div>
            <div className="form-group" style={{margin:0}}>
              <label>Data início</label>
              <input type="date" value={relFiltros.inicio} onChange={e=>setRelFiltros({...relFiltros,inicio:e.target.value})} />
            </div>
            <div className="form-group" style={{margin:0}}>
              <label>Data fim</label>
              <input type="date" value={relFiltros.fim} onChange={e=>setRelFiltros({...relFiltros,fim:e.target.value})} />
            </div>
          </div>

          {/* Botões exportar */}
          <div style={{display:"flex",gap:8,marginBottom:16}}>
            {[{fmt:"pdf",label:"📄 PDF"},{fmt:"excel",label:"📊 Excel"}].map(({fmt,label})=>(
              <button key={fmt} className="btn btn-ghost" style={{fontSize:12}}
                onClick={async()=>{
                  const token = localStorage.getItem("moobi_token")||""
                  const APIURL = process.env.REACT_APP_API_URL||"http://localhost:3001/api"
                  const params = new URLSearchParams({formato:fmt,
                    ...(relFiltros.cliente_id&&{cliente_id:relFiltros.cliente_id}),
                    ...(relFiltros.status&&{status:relFiltros.status})})
                  const r = await fetch(`${APIURL}/relatorios/rastreadores?${params}`,{headers:{Authorization:`Bearer ${token}`}})
                  const blob = await r.blob()
                  const url = URL.createObjectURL(blob)
                  if(fmt==="pdf") window.open(url,"_blank")
                  else { const a=document.createElement("a");a.href=url;a.download="rastreadores.xlsx";document.body.appendChild(a);a.click();document.body.removeChild(a) }
                }}>
                {label}
              </button>
            ))}
          </div>

          {/* Cards resumo */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:16}}>
            {[
              {label:"Total", valor:dados.length, cor:"#f1f5f9", icone:"📡"},
              {label:"Em uso", valor:counts.em_uso, cor:"#22c55e", icone:"🟢"},
              {label:"Estoque", valor:counts.estoque, cor:"#38bdf8", icone:"📦"},
              {label:"Manutenção", valor:counts.manutencao, cor:"#fbbf24", icone:"🔧"},
            ].map((s,i)=>(
              <div key={i} style={{background:"#0d1b2e",borderRadius:8,padding:"12px 14px",border:"1px solid #2d4166"}}>
                <div style={{fontSize:18,marginBottom:4}}>{s.icone}</div>
                <div style={{fontSize:20,fontWeight:700,color:s.cor}}>{s.valor}</div>
                <div style={{fontSize:11,color:"#64748b"}}>{s.label}</div>
              </div>
            ))}
          </div>

          {/* Tabela relatório */}
          <div style={{overflowX:"auto"}}>
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
              <thead>
                <tr style={{background:"#0d1b2e"}}>
                  {["IMEI","Marca/Modelo","Status","Cliente","Ativo","Chip","Última comunicação"].map(h=>(
                    <th key={h} style={{padding:"8px 12px",textAlign:"left",fontSize:10,color:"#64748b",fontWeight:600,textTransform:"uppercase"}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dadosFiltradosRel.map((r:any)=>{
                  const st = STATUS_CORES[r.status||"estoque"]||STATUS_CORES.estoque
                  return (
                    <tr key={r.id} style={{borderBottom:"1px solid rgba(45,65,102,0.3)"}}>
                      <td style={{padding:"7px 12px",fontFamily:"monospace"}}>{r.imei}</td>
                      <td style={{padding:"7px 12px"}}>{r.marca||"—"} {r.modelo||""}</td>
                      <td style={{padding:"7px 12px"}}>
                        <span style={{fontSize:10,padding:"1px 6px",borderRadius:8,background:st.bg,color:st.cor}}>{st.label}</span>
                      </td>
                      <td style={{padding:"7px 12px",color:"#94a3b8"}}>{r.ativo_cliente_nome||r.cliente_nome||"—"}</td>
                      <td style={{padding:"7px 12px"}}>{r.ativo_nome||"—"}{r.placa?` (${r.placa})`:""}</td>
                      <td style={{padding:"7px 12px",color:"#38bdf8"}}>{r.chip_numero||r.chip_iccid?.slice(-8)||"—"}</td>
                      <td style={{padding:"7px 12px",color:"#64748b"}}>
                        {r.ultima_comunicacao ? new Date(r.ultima_comunicacao).toLocaleString("pt-BR") : "—"}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Abas */}
      <div style={{display:"flex",gap:0,marginBottom:16,borderBottom:"1px solid #2d4166"}}>
        {([
          ["em_uso","🟢 Em uso",counts.em_uso,"#22c55e"],
          ["estoque","📦 Estoque",counts.estoque,"#38bdf8"],
          ["manutencao","🔧 Manutenção",counts.manutencao,"#fbbf24"],
        ] as const).map(([id,label,count,cor])=>(
          <button key={id} onClick={()=>setAbaAtiva(id)}
            style={{padding:"8px 20px",border:"none",background:"transparent",cursor:"pointer",
              fontFamily:"Inter",fontSize:13,fontWeight:abaAtiva===id?700:400,
              color:abaAtiva===id?cor:"#64748b",
              borderBottom:abaAtiva===id?`2px solid ${cor}`:"2px solid transparent",
              marginBottom:-1}}>
            {label} <span style={{fontSize:11,color:"#475569",marginLeft:4}}>({count})</span>
          </button>
        ))}
      </div>

      {/* Filtros */}
      <div style={{display:"flex",gap:12,marginBottom:16}}>
        <input placeholder="Buscar IMEI ou nome..." value={busca}
          onChange={e=>setBusca(e.target.value)} style={{flex:1,maxWidth:300}} />
        <select value={filtroCliente} onChange={e=>setFiltroCliente(e.target.value)} style={{minWidth:200}}>
          <option value="">Todos os clientes</option>
          {clientes.map((c:any)=><option key={c.id} value={c.id}>{c.razao_social}</option>)}
        </select>
      </div>

      {/* Tabela */}
      <div className="card" style={{padding:0,overflow:"hidden"}}>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead>
            <tr style={{background:"#0d1b2e"}}>
              {["IMEI","Marca/Modelo","Chip","Ativo vinculado","Cliente","Última comunicação","Status","Ações"].map(h=>(
                <th key={h} style={{padding:"10px 14px",textAlign:"left",fontSize:11,
                  color:"#64748b",fontWeight:600,textTransform:"uppercase"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={{padding:24,textAlign:"center",color:"#64748b"}}>Carregando...</td></tr>
            ) : filtrados.length===0 ? (
              <tr><td colSpan={7} style={{padding:24,textAlign:"center",color:"#64748b"}}>Nenhum rastreador encontrado</td></tr>
            ) : filtrados.map((r:any)=>{
              const st = STATUS_CORES[r.status||"estoque"] || STATUS_CORES.estoque
              return (
                <tr key={r.id} style={{borderBottom:"1px solid rgba(45,65,102,0.4)"}}>
                  <td style={{padding:"10px 14px"}}>
                    <div style={{fontFamily:"monospace",fontSize:12,fontWeight:600}}>{r.imei}</div>
                    {r.nome && <div style={{fontSize:10,color:"#64748b"}}>{r.nome}</div>}
                  </td>
                  <td style={{padding:"10px 14px"}}>
                    <div style={{fontSize:12,fontWeight:500}}>{r.marca||"—"}</div>
                    <div style={{fontSize:10,color:"#64748b"}}>{r.modelo||"—"}</div>
                  </td>
                  <td style={{padding:"10px 14px",fontSize:11}}>
                    {r.chip_numero||r.chip_iccid ? (
                      <div>
                        <div style={{color:"#38bdf8"}}>{r.chip_numero||r.chip_iccid?.slice(-8)}</div>
                        <div style={{fontSize:10,color:"#64748b"}}>{r.chip_operadora||"—"}</div>
                      </div>
                    ) : <span style={{color:"#475569"}}>Sem chip</span>}
                  </td>
                  <td style={{padding:"10px 14px",fontSize:12}}>
                    {r.ativo_nome ? (
                      <div>
                        <div style={{fontWeight:500}}>{r.ativo_nome}</div>
                        {r.placa && <div style={{fontSize:10,color:"#64748b"}}>{r.placa}</div>}
                      </div>
                    ) : <span style={{color:"#475569"}}>—</span>}
                  </td>
                  <td style={{padding:"10px 14px",fontSize:12,color:"#94a3b8"}}>
                    {r.ativo_cliente_nome||r.cliente_nome||"—"}
                  </td>
                  <td style={{padding:"10px 14px",fontSize:11}}>
                    {r.ultima_comunicacao ? (
                      <div>
                        <div style={{color:"#f1f5f9"}}>{new Date(r.ultima_comunicacao).toLocaleDateString("pt-BR")}</div>
                        <div style={{color:"#64748b"}}>{new Date(r.ultima_comunicacao).toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"})}</div>
                      </div>
                    ) : <span style={{color:"#475569"}}>—</span>}
                  </td>
                  <td style={{padding:"10px 14px"}}>
                    <span style={{fontSize:10,padding:"2px 8px",borderRadius:10,fontWeight:500,
                      background:st.bg,color:st.cor}}>{st.label}</span>
                  </td>
                  <td style={{padding:"10px 14px"}}>
                    <div style={{display:"flex",gap:4}}>
                      <button className="btn btn-ghost" style={{padding:"4px 8px",fontSize:11}}
                        title="Editar" onClick={()=>abrirEditar(r)}>✏️</button>
                      <button className="btn btn-ghost" style={{padding:"4px 8px",fontSize:11}}
                        title="Histórico" onClick={()=>abrirHistorico(r)}>📋</button>
                      {r.status==="estoque" && (
                        <button className="btn btn-ghost" style={{padding:"4px 8px",fontSize:11,color:"#fbbf24"}}
                          title="Mover para manutenção"
                          onClick={()=>{ if(window.confirm("Mover para manutenção?")) mudarStatus(r.id,"manutencao") }}>🔧</button>
                      )}
                      {r.status==="manutencao" && (
                        <button className="btn btn-ghost" style={{padding:"4px 8px",fontSize:11,color:"#38bdf8"}}
                          title="Mover para estoque"
                          onClick={()=>{ if(window.confirm("Mover para estoque?")) mudarStatus(r.id,"estoque") }}>📦</button>
                      )}
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      {/* Modal Novo/Editar */}
      {modal && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1000,
          display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div className="card" style={{width:"100%",maxWidth:580,maxHeight:"92vh",overflowY:"auto"}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:20}}>
              <h3>{editando?"✏️ Editar rastreador":"📡 Novo rastreador"}</h3>
              <button className="btn btn-ghost" style={{padding:"4px 8px"}} onClick={()=>setModal(false)}>✕</button>
            </div>

            <div className="form-grid">
              <div className="form-group full">
                <label>IMEI *</label>
                <input value={form.imei} onChange={e=>setForm({...form,imei:e.target.value})}
                  placeholder="000000000000000" style={{fontFamily:"monospace"}} />
              </div>

              <div className="form-group">
                <label>Marca *</label>
                <select value={form.marca} onChange={e=>{
                  setForm({...form,marca:e.target.value,modelo:"",servidor:"",porta:""})
                  setModeloInfo(null)
                }}>
                  <option value="">— Selecione a marca —</option>
                  {catalogoModelos.map(m=><option key={m.marca} value={m.marca}>{m.marca}</option>)}
                </select>
              </div>

              <div className="form-group">
                <label>Modelo *</label>
                <select value={form.modelo}
                  onChange={e=>selecionarModelo(form.marca, e.target.value)}
                  disabled={!form.marca}>
                  <option value="">— Selecione o modelo —</option>
                  {marcaSelecionada?.modelos.map((m:any)=>(
                    <option key={m.modelo} value={m.modelo}>{m.modelo}</option>
                  ))}
                </select>
              </div>

              {/* Info de configuração */}
              {modeloInfo && (
                <div className="form-group full">
                  <div style={{background:"#0c2a4a",border:"1px solid #0ea5e9",borderRadius:8,padding:12}}>
                    <div style={{fontSize:11,fontWeight:600,color:"#38bdf8",marginBottom:8}}>
                      ⚙️ Configuração Traccar — {form.marca} {form.modelo}
                    </div>
                    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                      <div>
                        <div style={{fontSize:10,color:"#64748b"}}>Servidor</div>
                        <div style={{fontSize:12,fontFamily:"monospace",color:"#f1f5f9"}}>{modeloInfo.servidor||"—"}</div>
                      </div>
                      <div>
                        <div style={{fontSize:10,color:"#64748b"}}>Porta</div>
                        <div style={{fontSize:12,fontFamily:"monospace",color:"#f1f5f9"}}>{modeloInfo.porta||"—"}</div>
                      </div>
                    </div>
                    <div style={{fontSize:10,color:"#475569",marginTop:6}}>
                      Configure esses dados no rastreador para conectar ao Traccar
                    </div>
                  </div>
                </div>
              )}

              <div className="form-group">
                <label>Servidor (personalizável)</label>
                <input value={form.servidor} onChange={e=>setForm({...form,servidor:e.target.value})}
                  placeholder="servidor.traccar.org" style={{fontFamily:"monospace"}} />
              </div>

              <div className="form-group">
                <label>Porta</label>
                <input type="number" value={form.porta} onChange={e=>setForm({...form,porta:e.target.value})}
                  placeholder="5000" />
              </div>

              <div className="form-group full">
                <label>📶 Chip SIM *</label>
                <select value={form.chip_id} onChange={e=>setForm({...form,chip_id:e.target.value})}>
                  <option value="">— Selecione o chip —</option>
                  {chips.filter((ch:any)=>!ch.rastreador_imei || ch.id===form.chip_id).map((ch:any)=>(
                    <option key={ch.id} value={ch.id}>
                      {ch.numero||ch.iccid} — {ch.operadora_nome||""}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Nome / Apelido</label>
                <input value={form.nome} onChange={e=>setForm({...form,nome:e.target.value})}
                  placeholder="Ex: Rastreador 01" />
              </div>

              <div className="form-group">
                <label>Número de série</label>
                <input value={form.numero_serie} onChange={e=>setForm({...form,numero_serie:e.target.value})}
                  placeholder="NS12345" />
              </div>

              <div className="form-group">
                <label>📅 Data de compra</label>
                <input type="date" value={form.data_compra}
                  onChange={e=>setForm({...form,data_compra:e.target.value})} />
              </div>

              <div className="form-group full">
                <label>Observações</label>
                <input value={form.observacoes} onChange={e=>setForm({...form,observacoes:e.target.value})}
                  placeholder="Observações adicionais..." />
              </div>
            </div>

            <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:20}}>
              <button className="btn btn-ghost" onClick={()=>setModal(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvar}>💾 Salvar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Histórico */}
      {modalHist && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1000,
          display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div className="card" style={{width:"100%",maxWidth:500,maxHeight:"80vh",overflowY:"auto"}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:16}}>
              <h3>📋 Histórico — {modalHist.imei}</h3>
              <button className="btn btn-ghost" style={{padding:"4px 8px"}} onClick={()=>setModalHist(null)}>✕</button>
            </div>
            {historico.length===0 ? (
              <div style={{textAlign:"center",padding:24,color:"#64748b"}}>
                Nenhum histórico de uso registrado
              </div>
            ) : historico.map((h:any)=>(
              <div key={h.id} style={{background:"#0d1b2e",borderRadius:8,padding:12,marginBottom:8,
                border:"1px solid #2d4166"}}>
                <div style={{fontWeight:600,fontSize:13}}>{h.ativo_nome||"—"}</div>
                {h.placa && <div style={{fontSize:11,color:"#64748b"}}>{h.placa}</div>}
                <div style={{fontSize:11,color:"#94a3b8",marginTop:4}}>
                  {h.data_inicio ? new Date(h.data_inicio).toLocaleDateString("pt-BR") : "—"}
                  {" → "}
                  {h.data_fim ? new Date(h.data_fim).toLocaleDateString("pt-BR") : "Atual"}
                </div>
                {h.motivo_saida && <div style={{fontSize:10,color:"#f59e0b",marginTop:2}}>{h.motivo_saida}</div>}
                <div style={{fontSize:10,color:"#475569",marginTop:2}}>{h.cliente_nome}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      {modalModelos && (
        <ModalModelosRastreador onFechar={()=>{ setModalModelos(false); carregarCatalogoModelos() }} />
      )}
    </div>
  )
}

// ───────────────────────────────────────────────────────────
// Modal de gestão do catálogo de modelos de rastreador (fabricante,
// modelo, servidor/porta de conexão, comandos de bloqueio). Alimenta o
// dropdown de "Marca/Modelo" no formulário de rastreadores.
// ───────────────────────────────────────────────────────────
function ModalModelosRastreador({ onFechar }: { onFechar: () => void }) {
  const [lista, setLista] = useState<any[]>([])
  const [carregando, setCarregando] = useState(true)
  const [form, setForm] = useState<any>({ fabricante:"", modelo:"", protocolo:"", servidor:"", porta:"", cmd_bloquear:"engineStop", cmd_desbloquear:"engineResume", suporta_bloqueio:false })
  const [salvando, setSalvando] = useState(false)
  const [editandoId, setEditandoId] = useState<string|null>(null)

  const carregar = async () => {
    setCarregando(true)
    try {
      const r = await axios.get(`${API}/modelos-rastreador`)
      setLista(r.data)
    } catch {} finally { setCarregando(false) }
  }
  useEffect(()=>{ carregar() },[])

  const limparForm = () => {
    setForm({ fabricante:"", modelo:"", protocolo:"", servidor:"", porta:"", cmd_bloquear:"engineStop", cmd_desbloquear:"engineResume", suporta_bloqueio:false })
    setEditandoId(null)
  }

  const editar = (m:any) => {
    setForm({ fabricante:m.fabricante, modelo:m.modelo, protocolo:m.protocolo||"", servidor:m.servidor||"", porta:m.porta||"", cmd_bloquear:m.cmd_bloquear||"engineStop", cmd_desbloquear:m.cmd_desbloquear||"engineResume", suporta_bloqueio:!!m.suporta_bloqueio })
    setEditandoId(m.id)
  }

  const salvar = async () => {
    if (!form.fabricante || !form.modelo) return alert("Fabricante e modelo são obrigatórios")
    setSalvando(true)
    try {
      if (editandoId) await axios.put(`${API}/modelos-rastreador/${editandoId}`, form)
      else await axios.post(`${API}/modelos-rastreador`, form)
      limparForm()
      await carregar()
    } catch { alert("Erro ao salvar modelo") } finally { setSalvando(false) }
  }

  const desativar = async (id:string) => {
    if (!window.confirm("Desativar este modelo? Ele deixará de aparecer no formulário de novo rastreador.")) return
    try { await axios.delete(`${API}/modelos-rastreador/${id}`); await carregar() } catch {}
  }

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
      <div style={{background:"#162035",borderRadius:16,padding:20,width:"100%",maxWidth:640,maxHeight:"88vh",overflowY:"auto",border:"1px solid #2d4166"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <h3 style={{fontSize:16,fontWeight:700,color:"#f1f5f9",margin:0}}>⚙️ Modelos de rastreador</h3>
          <button onClick={onFechar} style={{background:"none",border:"none",color:"#94a3b8",cursor:"pointer",fontSize:18}}>✕</button>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:16,background:"#1e2f4a",borderRadius:8,padding:12}}>
          <input value={form.fabricante} onChange={e=>setForm({...form,fabricante:e.target.value})} placeholder="Fabricante (ex: Suntech)"
            style={{background:"#0d1b2e",border:"1px solid #2d4166",borderRadius:8,color:"#f1f5f9",padding:8}} />
          <input value={form.modelo} onChange={e=>setForm({...form,modelo:e.target.value})} placeholder="Modelo (ex: ST8300)"
            style={{background:"#0d1b2e",border:"1px solid #2d4166",borderRadius:8,color:"#f1f5f9",padding:8}} />
          <input value={form.servidor} onChange={e=>setForm({...form,servidor:e.target.value})} placeholder="Servidor (ex: suntech.moobifleet.com.br)"
            style={{background:"#0d1b2e",border:"1px solid #2d4166",borderRadius:8,color:"#f1f5f9",padding:8}} />
          <input value={form.porta} onChange={e=>setForm({...form,porta:e.target.value})} placeholder="Porta" type="number"
            style={{background:"#0d1b2e",border:"1px solid #2d4166",borderRadius:8,color:"#f1f5f9",padding:8}} />
          <input value={form.protocolo} onChange={e=>setForm({...form,protocolo:e.target.value})} placeholder="Protocolo Traccar (opcional)"
            style={{background:"#0d1b2e",border:"1px solid #2d4166",borderRadius:8,color:"#f1f5f9",padding:8,gridColumn:"1 / -1"}} />
          <div style={{gridColumn:"1 / -1",display:"flex",gap:8}}>
            <button onClick={salvar} disabled={salvando}
              style={{flex:1,background:"#0ea5e9",border:"none",borderRadius:8,color:"#fff",padding:10,cursor:"pointer",fontWeight:700}}>
              {salvando ? "Salvando..." : editandoId ? "Atualizar modelo" : "Adicionar modelo"}
            </button>
            {editandoId && (
              <button onClick={limparForm}
                style={{background:"transparent",border:"1px solid #2d4166",borderRadius:8,color:"#94a3b8",padding:"10px 14px",cursor:"pointer"}}>
                Cancelar
              </button>
            )}
          </div>
        </div>

        {carregando ? (
          <p style={{fontSize:12,color:"#64748b",textAlign:"center",padding:16}}>Carregando...</p>
        ) : lista.length === 0 ? (
          <p style={{fontSize:12,color:"#64748b",textAlign:"center",padding:16}}>Nenhum modelo cadastrado ainda.</p>
        ) : (
          lista.map((m:any)=>(
            <div key={m.id} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",background:"#1e2f4a",borderRadius:8,marginBottom:6}}>
              <div style={{flex:1}}>
                <div style={{fontSize:13,color:"#f1f5f9"}}>{m.fabricante} {m.modelo}</div>
                <div style={{fontSize:10,color:"#475569",fontFamily:"monospace"}}>{m.servidor||"—"}{m.porta?`:${m.porta}`:""}</div>
              </div>
              <button onClick={()=>editar(m)} style={{background:"none",border:"none",color:"#38bdf8",cursor:"pointer"}}>✏️</button>
              <button onClick={()=>desativar(m.id)} style={{background:"none",border:"none",color:"#f87171",cursor:"pointer"}}>🗑️</button>
            </div>
          ))
        )}
      </div>
    </div>
  )
}
